import { ListingProvider } from '@/context/listing';
import i18n from '@/i18n';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';

// components
import Filters from '@/kenwood/components/organisms/Filters';
import FiltersPlus from '@/kenwood/components/organisms/FiltersPlus';
import { isTrue } from '@/utils/Common/Booleans';

export default () => {
  i18n.loadNamespaces('listing', () => {
    const el = document.getElementById('js-r-entry-ken-listing-filters');
    if (!el) return;
    const FiltersApp = () => (
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<div />}>
          <ListingProvider>
            {isTrue(DLG.config.KwPlpPlusLayout) ? (
              <FiltersPlus {...el.dataset} />
            ) : (
              <Filters {...el.dataset} />
            )}
          </ListingProvider>
        </Suspense>
      </I18nextProvider>
    );
    ReactDOM.render(<FiltersApp />, el);
  });
};
